import { ICourseComponentPart } from "../../../../App/Analytics/Common";
import {
  gridColumnName,
  gridLayoutName,
  isClozePart,
  isDividerPart,
  isDocumentPart,
  isGridPart,
  isImagePart,
  isListWithOptionsPart,
  isListWithoutOptionsPart,
  isMultipleChoicePart,
  isSingleChoicePart,
  isSpacerPart,
  isTeachingPart,
  isUnorderedListPart,
} from "../../../pages/CourseAuthor/CourseInstruction/Parts/util";
import { ICourseInstructionContentPart } from "../../types";

export const partTitle = (contentPart: ICourseInstructionContentPart | ICourseComponentPart): string => {
  if (isTeachingPart(contentPart)) {
    return "Explanation";
  }

  if (isMultipleChoicePart(contentPart)) {
    return "Multiple Choice";
  }

  if (isSingleChoicePart(contentPart)) {
    return "Single Choice";
  }

  if (isClozePart(contentPart)) {
    return "Gap Sentence";
  }

  if (isUnorderedListPart(contentPart)) {
    return "List Items";
  }

  if (isListWithoutOptionsPart(contentPart)) {
    return "List Items (in order)";
  }

  if (isListWithOptionsPart(contentPart)) {
    return "Order Items";
  }

  if (isGridPart(contentPart)) {
    return `Grid (${gridColumnName(contentPart)}) - Layout [${gridLayoutName(contentPart)}]`;
  }

  if (isDividerPart(contentPart)) {
    return "Divider";
  }

  if (isSpacerPart(contentPart)) {
    return "Spacer";
  }

  if (isImagePart(contentPart)) {
    return "Image";
  }

  if (isDocumentPart(contentPart)) {
    return "Document";
  }

  return "";
};
